<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Relatório {{ rel_name }}</h1>

			<div>
				<pdfBtn v-if="pdf_btn"
					type="datatable" 
					:filter="string_filter" 
					:title="pdf_title"
					:datatable="pdf_datatable"
					:external="false"
					:data_head="data_head" 
					:data_body="data_body" 
				/>

				<transition mode="out-in" name="leftIn">
					<button v-if="button.display" class="btn btn-sm" :class="button.class" @click="btn_click">{{ button.label }}</button>
				</transition>
			</div>
	    </div>

		<transition mode="out-in" name="leftIn">
			<router-view 
				:rel_name.sync="rel_name" 
				:button.sync="button"
				:pdf.sync="pdf_btn" 
				:pdf_title.sync="pdf_title"
				:pdf_datatable.sync="pdf_datatable"
				:pdf_header.sync="data_head"
				:pdf_body.sync="data_body"
				:pdf_string_filter.sync="string_filter"
				ref="rel_content"
			></router-view>
		</transition>
	</section>
</template>

<script>
	import api    from "@/mixins/api.js"
	import pdfBtn from "@/components/Tools/Pdf.vue"

	export default {
		name: 'Relatorios',
		mixins: [api],
		components: { pdfBtn },

		data() { 
			return { 
				rel_name: null,
				pdf_btn: false,
				button: {},
				string_filter: "",
				data_head: [],
				data_body: [],
				pdf_title: "",
				pdf_datatable: ""
			}
		},

		computed:{
			view_nome(){ 
				return this.$store.state.config_view_menu.denuncia_detalhe;
			}
		},

		beforeRouterUpdate() {
			this.button = {};
		},

		methods: {
			btn_click() { 
				this.$refs.rel_content.btn_click();
			},
		}
	};
</script>

<style>
</style>